import React from 'react';
import { cn } from '@/lib/utils';

const EMOTES = [
  // Creative / Art
  '🎨','🖼️','✏️','🖌️','🧵','🧶','🪡','🪢','🧩','📐','📏','📎',
  // Photo / Video / Cinema
  '📸','📷','🎞️','🎬','🎥','📹','🧪','📺','📼','🖥️','🖱️',
  // Gaming / Tech
  '🎮','🕹️','💻','⌨️','🖲️','🧠','⚙️','🔧','🛠️','🔩','🪛','🧰','🧬','🤖','📡','🛰️','💾','🧪',
  // Music / Audio / Party
  '🎵','🎶','🎧','🎤','🎸','🎻','🥁','🎹','📻','🪩',
  // Nature / Outdoors
  '🌿','🌸','🌻','🌊','🔥','💧','🌙','⭐','☀️','🌈','⛰️','🏝️','🌋','🌪️','🌧️','❄️','🍂','🍃',
  // Sports
  '⚽','🏀','🏈','🎾','🏐','⚾','🥊','🚴','🏃',
  // Fashion / Lifestyle
  '👗','👟','💄','💍','👜','💅','🕶️',
  // Food
  '🍕','🍣','🍔','🍜','🍩','🍪','🍫','🍦','🍰','🥐','🥑','🍓','🍎','🍉','🍇','🍒','🍙','🍱',
  // Anime / Aesthetic
  '🌸','🪄','✨','💫','🌀','🧸','🎀','🦄','🐉',
];

// Twemoji URL helper for pixelated preview
const emojiToCodepoints = (emoji: string) => 
  Array.from(emoji).map(c => c.codePointAt(0)!.toString(16)).join('-');
  
export const twemojiUrl = (emoji: string) => 
  `https://cdn.jsdelivr.net/gh/twitter/twemoji@latest/assets/72x72/${emojiToCodepoints(emoji)}.png`;

interface EmojiPickerProps {
  selectedEmoji?: string;
  onEmojiSelect: (emoji: string) => void;
  className?: string;
}

export default function EmojiPicker({ selectedEmoji, onEmojiSelect, className }: EmojiPickerProps) {
  return (
    <div className={cn("max-h-48 overflow-y-auto rounded-md border p-2 bg-background/40", className)}>
      <div className="grid grid-cols-8 gap-2">
        {EMOTES.map((emoji) => (
          <button 
            key={emoji} 
            type="button" 
            onClick={() => onEmojiSelect(emoji)}
            className={cn(
              "h-9 w-9 rounded-md flex items-center justify-center border transition-colors",
              selectedEmoji === emoji 
                ? "border-primary bg-primary/10" 
                : "border-border hover:bg-muted/30"
            )}
          >
            {/* Pixelated preview using Twemoji */}
            <img 
              src={twemojiUrl(emoji)} 
              alt={emoji} 
              className="h-6 w-6" 
              style={{ imageRendering: 'pixelated' as any }} 
            />
          </button>
        ))}
      </div>
    </div>
  );
}

export { EMOTES };